import { QUESTION_SET } from 'actions/getValidConvertibleInstanceAction';
import { Title } from 'components/layout/header/title';
import { AtlasWebIframe } from 'components/shared/atlasWebIframe';
import { HpChildComponentProps } from 'components/shared/componentWithModal/componentWithModal';

export const Audit = ({ selectedPolicy }: HpChildComponentProps): JSX.Element => {
  const { policyDetailsId, historyId } = selectedPolicy;
  return (
    <>
      <Title title="POLICY AUDIT" icon="document-circle" id="audit" />
      <AtlasWebIframe policyDetailsId={policyDetailsId} historyId={historyId} questionSetType={QUESTION_SET.AUDIT} />
    </>
  );
};
